import * as React from 'react';

export const StepArrowSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12.29" height="12.29" viewBox="0 0 12.29 12.29"><path d="M10930.3,13733.034a.861.861,0,0,1,0-1.243l4.8-4.644-4.792-4.652a.855.855,0,0,1,0-1.239.929.929,0,0,1,1.282,0l5.457,5.3a.85.85,0,0,1-.023,1.209l-5.437,5.267a.919.919,0,0,1-.644.255A.91.91,0,0,1,10930.3,13733.034Zm-5.04,0a.86.86,0,0,1,0-1.243l4.8-4.644-4.794-4.652a.855.855,0,0,1,0-1.239.93.93,0,0,1,1.283,0l5.461,5.3a.857.857,0,0,1-.03,1.209l-5.435,5.267a.937.937,0,0,1-1.285,0Z" transform="translate(-10924.998 -13720.999)" fill="#9f9f9f"/></svg>
  );
};
